import React, { useContext, useEffect, useMemo, useState } from 'react'
import {
  Accordion, AccordionDetails, AccordionSummary, Button,
  Card, CardActionArea, CardContent, CardMedia, DialogActions,
  TextField, Typography, makeStyles,
} from '@cicero/ui'
import { FormLabel } from '@material-ui/core'
import { LOGGER } from '@cicero/data/utils'
import { EditorContext, IDashboardWidgetElement, IEditorWidget } from '../../EditorService'

export const WidgetConfigForm = ({ leaf, onSave, onCancel, onDelete }: {
  leaf?: IDashboardWidgetElement
  onSave: (leaf: IDashboardWidgetElement) => any
  onCancel: () => any
  onDelete?: () => any
}) => {
  const { widgetTypeList, widgetPreviewWrapper, widgetPreviewContent, widgetPreviewForm } = useWidgetFormStyles()
  const [formState, setFormState] = useState<any>(leaf ? { ...leaf, text: leaf.children[0]?.text || '' } : {} as any)
  const [activeWidget, setActiveWidget] = useState<IEditorWidget>(leaf?.widgetType as any)
  const service = useContext(EditorContext)
  const widgets = useMemo(() => Array.from(service.widgets.values()), [service])

  useEffect(() => {
    if (leaf?.widgetType && leaf?.widgetType !== activeWidget.id) {
      const widget = service.widgets.get(leaf.widgetType)
      if (widget) { setActiveWidget(widget) }
      LOGGER.debug('Widget', widget, leaf)
    }
  }, [leaf])

  return <form>
    <Accordion square expanded={!formState.widgetType} disabled={!!formState.widgetType}>
      <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
        <Typography>Choose Widget Type</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ul className={widgetTypeList}>
          {
            widgets.map(widget =>
              <li
                key={widget.id}
                onClick={() => {
                  setFormState({ type: 'widget', widgetType: widget.id, title: leaf?.title || '' })
                  setActiveWidget(widget)
                }}>
                <WidgetTypeTile widgetType={widget} />
              </li>
            )
          }
        </ul>
      </AccordionDetails>
    </Accordion>
    <Accordion square expanded={!!formState.widgetType} disabled={!formState.widgetType}>
      <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
        <Typography>Configure</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {
          activeWidget
            ? <div className={widgetPreviewWrapper}>
              <form className={widgetPreviewForm}>
                <TextField
                  autoFocus={!leaf?.text}
                  label="Widget Title"
                  value={formState.title}
                  onChange={(e) => setFormState({ ...formState, title: e.target.value })}
                />
                <TextField label="Size" value={formState.size || 1} onChange={(e) => setFormState({ ...formState, size: e.target.value })} type="number" />
                { (activeWidget.configSchema || []).map((config) =>
                  <div key={config.key}>
                    <FormLabel component="legend">{config.label}</FormLabel>
                    {
                      config.renderForm(
                        formState[config.key] === undefined ? config.defaultValue : formState[config.key],
                        (value) => config.validate(value) === null && setFormState({ ...formState, [config.key]: value })
                      )
                    }
                  </div>
                ) }
                {/* { activeWidget.formRenderer
                  ? activeWidget.formRenderer(formState as IDashboardWidgetElement, (config) => { setFormState({ ...formState, config }) })
                  : <p>No Form</p>
                } */}
                <DialogActions>
                  <Button onClick={() => onSave(formState as IDashboardWidgetElement)}>{ leaf ? 'Save' : 'Add'}</Button>
                  <Button onClick={() => onCancel()}>Cancel</Button>
                  { onDelete ? <Button onClick={() => onDelete()}>Delete</Button> : null }
                </DialogActions>
              </form>
              <div className={widgetPreviewContent}>
                { service.renderWidget(formState) }
              </div>
            </div>
            : null
        }

      </AccordionDetails>
    </Accordion>
  </form>
}

export const WidgetTypeTile = ({ widgetType }: { widgetType: IEditorWidget }) => {
  return <Card>
    <CardActionArea>
      <CardMedia image={widgetType.image} height="120" component="img" />
      <CardContent>
        <Typography variant="h5">{ widgetType.name }</Typography>
        <Typography variant="body2">{ widgetType.description }</Typography>
      </CardContent>
    </CardActionArea>
  </Card>
}


const useWidgetFormStyles = makeStyles({
  widgetTypeList: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: '6px',
    background: '#EEE',

    '& li': {
      maxWidth: 245,
      margin: 6,
      listStyleType: 'none',
    },
  },
  widgetPreviewWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  widgetPreviewContent: {
    margin: 16,
    borderRight: '4px solid #CCC',
    flexGrow: 3,
  },
  widgetPreviewForm: {
    flexGrow: 1,

    '& > *': {
      width: '100%',
      marginBottom: 32,
    },
  },
})
